import * as types from '../types'

export const initialState = {
  text: 'Continue',
  wait: false,
  backButtonClicked: false,
  disabled: false,
  lockedOut: false,
  deprovisioned: false,
  missingData: false,
  serviceError: false,
  viewHelp: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.VIEW_BACK:
      return Object.assign({}, state, {
        backButtonClicked: true,
        lockedOut: false,
        deprovisioned: false,
        missingData: false,
        serviceError: false
      })
    case types.VIEW_NEXT:
      return Object.assign({}, state, {
        backButtonClicked: false
      })
    case types.UPDATE_FORM_SUBMIT_TEXT:
      return Object.assign({}, state, {
        text: payload
      })
    case types.UPDATE_FORM_SUBMIT_DISABLED:
      return Object.assign({}, state, {
        disabled: payload
      })
    case types.UPDATE_FORM_SUBMIT_WAIT:
      return Object.assign({}, state, {
        wait: payload
      })
    case types.UPDATE_FORM_LOCKED_OUT:
      return Object.assign({}, state, {
        lockedOut: true
      })
    case types.UPDATE_FORM_DEPROVISIONED:
      return Object.assign({}, state, {
        deprovisioned: true
      })
    case types.UPDATE_FORM_MISSING_DATA:
      return Object.assign({}, state, {
        missingData: true
      })
    case types.TOGGLE_HELP_MODAL:
      return Object.assign({}, state, {
        viewHelp: !state.viewHelp
      })
    case types.TOGGLE_SERVICE_ERROR:
      return Object.assign({}, state, {
        serviceError: true
      })
    default:
      return state
  }
}
